import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { Circles } from "react-loader-spinner"

import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { loginValidation } from '../../components/validationSchema';
import { NavBar } from '../../components/navbar'
import { logo } from '../../assets'
import { colors } from '../../colors'
import { Button } from '../../components/button'
import { Link } from 'react-router-dom'
import Spinner from '../../components/spinner';
import { login, reset } from '../../pages/features/auth/authSlice'


import { 
    Container,
    InputContainer
 } from '../signup'



const Login = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');

    const { user, isLoading, isError, isSuccess, message } = useSelector(state => state.auth);

    const [isSuccessful, setIsSuccessful] = useState(false);
   
    const { isLoggedIn } = useSelector(state => state.auth);
    
    useEffect(() => {
        if (isError){
            toast.error(message);
        }

        if (isSuccess || isLoggedIn){
            toast.success("Login Successful ",{
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  })

            
            /* A function that is used to navigate to a different page. */
            alert("Login successfully")
            navigate('/dashboard/home');
        }
        dispatch(reset());

    }, [user, isError, isSuccess, message, navigate, dispatch]);


    const onSubmit = (data) => {

        data.preventDefault();

        if (userEmail === "" ||userPassword === "") {
            toast.error("Please fill all the fields", {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
            
          }else{
            const userData = {
                userEmail,
                userPassword
            }
            dispatch(login(userData))
          }

    };



    if (isLoading) {
        return <Spinner />; 
    }

    if(isSuccessful){
        
    }


  return (
    <Container>
        <NavBar/>
        <form onSubmit={onSubmit} >
            <img src={logo} alt="" />
            <h1>Log in to your account</h1>
            <p>Welcome back! Please enter your details</p>
            
            <InputContainer>
                <label htmlFor="name">Email</label>
                <input 
                    name='userEmail' 
                    type="email" 
                    id='userEmail'
                    autoComplete='on'
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    placeholder='Enter your email' 
                     
                />
            </InputContainer>

            <InputContainer>
                <label htmlFor="password">Password</label>
                <input 
                    name='password' 
                    type="password" 
                    id='password'
                    autoComplete='on'
                    value={userPassword}
                    onChange={(e) => setUserPassword(e.target.value)}
                    placeholder='Enter password' 
                    // required 
                />
            </InputContainer>

            <CheckPassword>
                <Remember>
                    <input type="checkbox" name="" id="" />
                    <p>Remember Password</p>
                </Remember>

                <span> <Link to='/forgot-password'>Forgot Password?</Link></span>
            </CheckPassword>

            <Button filled bgColor={'#2A870E'} noIcon text={'Sign in'} />
        </form>

        <small>Don't have an account? <span> <Link to='/sign-up'> Sign Up</Link></span> </small>
        
    </Container>
  )
}


const CheckPassword = styled.div`

    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    & span{
        color: ${colors.secondary};
        font-weight: 500;
        font-size: 14px;

        & a{
            color: ${colors.secondary};
        }
    }
    
`

const Remember = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px 0;

    & > input {
        /* width: 50%; */
    }

    & p{
        padding-left: 5px;
        font-size: 14px;
        font-weight: 500;
    }
`


export {Login}